import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton'
import SurveyHistory from '../SurveyHistory'

export default {
    props: {
        /**
         * The main question content
         */
        question: {
            type: Object
        },
        /** 
         * Reponse for the question
        */
        oresponse: {
			type: [Object, Array, Number]
		},
        response: {
            type: [Object, Number, Array]
        },
        event: {
            type: Object
        },
        patient: {
            type: Object
        },
        qNum: {
            type: Number
        },
        qDate: {
            type: String
        }
    },

    data() {
        return {
            showEdit: false,
            savingEdit: false
        }
    },

    methods: {
        checkIfMandatory() {
            if(Array.isArray(this.question.validations) && 
                this.question.validations.length > 0) {
                    for(let obj of this.question.validations) {
                        if(obj && "mandatory" in obj && JSON.parse(JSON.stringify(obj)).mandatory)
                            return true
                        else if(obj && "mandatory" in obj && !JSON.parse(JSON.stringify(obj)).mandatory)
                            return false
                        else continue
                    }
                } 
            else
                return false
        },

        checkIfDisalFutDates() {
            if(Array.isArray(this.question.validations) && this.question.validations.length > 0) {
                return this.question.validations.some((obj) => 
                    obj && Object.keys(obj).includes('before') && JSON.parse(JSON.stringify(obj)).before == 'tomorrow' && 
                    Object.keys(obj).includes('type') && JSON.parse(JSON.stringify(obj)).type == 'range'
                )
            } 
            else
                return false
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getPatientSurveys',
            'getPatientEvents'
        ]),
        patientSurveys() {
            return this.getPatientSurveys(this.patient.id)
        },
        survey() {
            return this.patientSurveys.filter(survey => survey.hasOwnProperty('message')).find((survey) => survey.message[0] === this.event.message)
        },
        updateIndex() {
            return this.event.question.findIndex(({id}) => id === this.question.id)
        }
    },

    components: {
        LoadingButton,
        SurveyHistory,
    }

}